import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayButtonComponent } from './play-button.component';
import { IconsModule } from '../../icons/icons.module';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [
    PlayButtonComponent
  ],
  exports: [
    PlayButtonComponent
  ],
  imports: [
    CommonModule,
    IconsModule,
    SharedModule
  ]
})
export class PlayButtonModule { }
